import { sendData,getData } from './../../misc/server.js';
export default {
  state: {
    data:[],
    loading:false,
    current_township:null,
  },
  mutations: {
  
   
    setData(state,payload)
    {
        state.data=payload;
        
    },
    setLoader(state,payload)
    {
        state.loading=payload;
    },
    setCurrentTownship(state,payload)
    {
      state.current_township=payload;
      localStorage.setItem("township_id",payload);
    }
   
   
  },
   actions: {
   

    getTownships({commit})
    {
        var url="/townships/get";
        
        commit("setLoader",true);
        getData(url,(response)=>{
            
            commit("setLoader",false);
            commit("setData",response.townships);
            
        })
    },
    setCurrentTownship({commit},data)
    {
      commit("setCurrentTownship",data.township_id);
    }
   

  },
  getters: 
  {

        initial_townships(state)
        {
            return state.data;
        },
        initial_townships_loading(state)
        {
            return state.loading;
        },
        current_township(state)
        {
          return state.current_township;
        }
      

  }

}